
import Vue from 'vue'
export default Vue.extend({
  name: 'HintTooltip',
  props: {
    copy: {
      required: true,
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    timeout: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      isHintTooltipActive: false,
      hintTooltipTimeout: this.timeout,
      hintTooltipTimeoutID: -1 as any,
    }
  },
  methods: {
    showHintTooltip() {
      this.isHintTooltipActive = true;

      this.hintTooltipTimeoutID = setTimeout(() => {
        this.isHintTooltipActive = false
      }, this.hintTooltipTimeout);
    },
    hideHintTooltip() {
      this.isHintTooltipActive = false;
      clearTimeout(this.hintTooltipTimeoutID);
    },
  },
})
